// Signature choreography from polished-v4-logo-nucleus.
// Only coordinate conversion and RAF ownership change for the scaled Blade host.
export function choreoEase(t) {
    t = Math.max(0, Math.min(1, t));
    return t*t*t*(t*(t*6 - 15) + 10);
}

export function createChoreography({ stack, featureEls, getScale, setOrbitBoost, changed, now = () => performance.now() }) {
    let choreographyRunning = false;
    let states = [], start = 0, cleanupAt = 0;
    const duration = 1080;

    function finish() {
        featureEls.forEach(el => {
            el.style.translate = '';
            el.style.rotate = '';
            el.style.animation = '';
            el.classList.remove('hero3d-orbiting');
        });
        setOrbitBoost(1);
        choreographyRunning = false;
        stack.setAttribute('aria-disabled', 'false');
        changed(false);
    }

    function runSignatureOrbit() {
        if (choreographyRunning) return false;
        choreographyRunning = true;
        cleanupAt = 0;
        stack.classList.remove('hero3d-pulse', 'hero3d-choreo');
        void stack.offsetWidth;
        stack.classList.add('hero3d-pulse', 'hero3d-choreo');
        stack.setAttribute('aria-disabled', 'true');

        const stackRect = stack.getBoundingClientRect();
        const cx = stackRect.left + stackRect.width/2;
        const cy = stackRect.top + stackRect.height/2;
        const scale = getScale();
        states = featureEls.map((el, index) => {
            const r = el.getBoundingClientRect();
            // Browser rectangles are screen pixels; CSS translate uses artboard units.
            const dx = (r.left + r.width/2 - cx) / scale;
            const dy = (r.top + r.height/2 - cy) / scale;
            return { el, index, dx, dy, radius:Math.hypot(dx,dy), angle:Math.atan2(dy,dx) };
        });
        featureEls.forEach(el => {
            el.classList.add('hero3d-orbiting');
            el.style.animation = 'none';
        });
        setOrbitBoost(3.25);
        start = now();
        changed(true);
        return true;
    }

    // Called by the scene's single RAF together with its Three.js renderer.
    function update(time) {
        if (cleanupAt && time >= cleanupAt) {
            stack.classList.remove('hero3d-choreo', 'hero3d-pulse');
            cleanupAt = 0;
        }
        if (!choreographyRunning) return;
        const t = Math.max(0, Math.min(1, (time-start)/duration));
        const e = choreoEase(t);
        const theta = Math.PI * 2 * e;
        const radialPulse = 1 - 0.060*Math.sin(Math.PI*t) + 0.014*Math.sin(Math.PI*2*t);
        states.forEach(s => {
            const a = s.angle + theta;
            const rr = s.radius * radialPulse;
            const tx = Math.cos(a)*rr - s.dx;
            const ty = Math.sin(a)*rr - s.dy;
            s.el.style.translate = `${tx.toFixed(2)}px ${ty.toFixed(2)}px`;
            const bank = Math.sin(Math.PI*t)*Math.sin(a)*3.3;
            s.el.style.rotate = `${bank.toFixed(2)}deg`;
        });
        if (t === 1) { finish(); cleanupAt = time + 80; }
    }

    function cancel() {
        if (choreographyRunning) finish();
        cleanupAt = 0;
        stack.classList.remove('hero3d-choreo', 'hero3d-pulse');
    }
    return { runSignatureOrbit, update, cancel, get running() { return choreographyRunning; } };
}
